module.exports = __webpack_public_path__ + "img/step2.c4051417.svg";